import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addgender',
  templateUrl: './addgender.component.html',
  styleUrls: ['./addgender.component.css']
})
export class AddgenderComponent implements OnInit ,AfterViewInit {

  @ViewChildren('input')firstipcontrol;

  formname:String="Gender"; 

//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
isprivilage: boolean = false;
showProgress: boolean = false;

//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;
//Edit Get Values
genderColl:any=[];
genderBO:any={};

genderid:number=0

genderform=new FormGroup({
  genderid:new FormControl(0),          
  gendername:new FormControl('',Validators.required),  
 inactive:new FormControl(false),  
});


constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.genderid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
   try{
       this.isaddmode=true;
       this.genderform.reset();
       this.fnInitializeFormGroup(); 

       if(this.genderid>0){
         this.fngetGender();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.genderid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}
ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}
fnInitializeFormGroup(){
   this.genderform.setValue({
    genderid:0,    
    gendername:'',
     inactive:false              
   })
}

//Get 
fngetGender() {   
  if (this.showProgress) {
    return;
  }      
     var data = {
       'genderid':this.genderid,
       'companyid':this.loginService.fnGetCompanyId()          
     }
     this.appService.getGender(data)
     .subscribe(
       (res)=>{                
         if(res.json().status===200){ 
          this.fnHideProgress();
 
           this.genderColl=res.json().result;
           var editdata = this.genderColl[0];        
           this.fnEditMode(editdata);
           this.genderBO=editdata;
         }
         else {
          this.fnHideProgress();

           this.loginService.fnAPIError(res.json())
         }
         
     },
     (err)=>{    
      this.fnHideProgress();
      
       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
   try{
    if (this.saveloading) {
      return;
    }
     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.genderform.valid){
         //Check
         this.saveloading = true;

         var data = {
               'genderid': this.genderid,                      
               'gendername':this.genderform.get('gendername').value, 
               'inactive':this.genderform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                              
         }

       
         this.appService.fnCheckGender(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.genderform.get('genderid').value>0){
                       //Update 
                       this.fnSetGender(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertGender(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){ this.saveloading = false;
                       this.genderform.controls['gendername'].setErrors({'notfound': true});
                     }
               }
             }
             else { this.saveloading = false;
               this.loginService.fnAPIError(res.json())
             }
         },
         (err)=>{ this.saveloading = false;
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){ this.saveloading = false;
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertGender(data){    
 
   this.appService.fnInsertGender(data).subscribe(
     (res)=>{ this.saveloading = false;
       if(res.json().status===200){  
         if(res.json().result!=""){
           this.toastr.success('', "The new gender has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.gendername);

           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err)=>{ this.saveloading = false;
       this.toastr.error('Error', err);
     });

}

//Set
fnSetGender(data){    

this.appService.fnSetGender(data).subscribe(
 (res)=>{ this.saveloading = false;
   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The gender has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.genderid,data.gendername);
             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
 (err)=>{ this.saveloading = false;
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{
  this.router.navigate(['/Gender']);
}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.genderform.setValue({ 
  genderid:deptBO.genderid,     
  gendername:deptBO.gendername,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
}


private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}







}
